<template>
    <div class="right-box">
        <title1 title="实时告警" subTitle="Real-time Alarm" class="mt-80"/>
        <div class="flex justify-between mt-80">
            <div
                v-for="(item, i) in target1"
                :key="'target1' + i"
                class="flex align-center justify-center target3">
                <img v-if="item.number > 0" class="img" :src="item.iconAt" />
                <img v-else class="img" :src="item.icon" />
                <div class="flex flex-direction align-center">
                    <div class="label">{{ item.label}}</div>
                    <div class="text" :style="{'color': item.number > 0 ? '#FF4348' : ''}">{{ item.number }}</div>
                </div>
            </div>
        </div>
        <div class="flex video-box-new flex-wrap mt-80">
            <div
                v-for="(item, index) in videoList"
                :key="'videoList' + index"
                class="video-item-new">
                <video
                    :ref="`my-player${index}`"
                    :playUrl="item.url"
                    class="video video-js"
                    muted>
                </video>
            </div>
        </div>

        <title1 class="mt-150" type="2" title="最新告警列表信息" />
        <div class="box-1 mt-100" style="height:760px">
            <dv-scroll-board :config="config" class="newTable"/>
        </div>
    </div>
</template>

<script>
import title1 from '@/views/exposition/components/title1'
import { formatTime } from '@/utils/index'
import { dataInterface } from "@/api/dataInterfaceApi"
export default {
    components: {
        title1
    },
    data() {
        let { stationId } = this.$route.query
        return {
            stationId: stationId,
            target1: [
                {
                    icon: require('@/assets/images/exposition/chd-gj-1.png'),
                    iconAt: require('@/assets/images/exposition/chd-gj-1-at.png'),
                    number: '',
                    label: '消防系统'
                },
                {
                    icon: require('@/assets/images/exposition/chd-gj-2.png'),
                    iconAt: require('@/assets/images/exposition/chd-gj-2-at.png'),
                    number: '',
                    label: '电池系统'
                },
                {
                    icon: require('@/assets/images/exposition/chd-gj-3.png'),
                    iconAt: require('@/assets/images/exposition/chd-gj-3-at.png'),
                    number: '',
                    label: '换电系统'
                },
                {
                    icon: require('@/assets/images/exposition/chd-gj-4.png'),
                    iconAt: require('@/assets/images/exposition/chd-gj-4-at.png'),
                    number: '',
                    label: '站控系统'
                },
                {
                    icon: require('@/assets/images/exposition/chd-gj-5.png'),
                    iconAt: require('@/assets/images/exposition/chd-gj-5-at.png'),
                    number: '',
                    label: '充电系统'
                },
            ],
			config: {
				headerBGC: "rgba(53, 149, 147, 0.2)",
				headerHeight: 42,
				carousel: "single",
				hoverPause: true,
				oddRowBGC: "rgba(53, 149, 147, 0)",
				evenRowBGC: "rgba(53, 149, 147, 0)",
				rowNum: 3, //表格行数
				header: ["告警时间", "设备编码", "告警类别", "告警内容"],
				data: [],
			},
            videoObj:{},
            videoList: []
        }
    },
    methods: {
        getData(data) {
            // 实时告警
            this.shishigaojing(data)
            // 告警列表
            this.gaojingliebiao(data)
            // 获取站点监控视频
            this.getDeviceList()
        },

		// 实时告警
		shishigaojing(data) {
			let _this = this
			let params = {
				'enCode': "TiDB-zhandian-shishigaojing",
				"@station_id": _this.stationId,
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return
				// let data = res[0] || {}
                res.map( (item, i) => {
                    this.target1[i].number = item.alarmTimesNum
                })
			})
			.catch((err) => {
				console.log(err);
			})
		},

		// 告警列表
		gaojingliebiao(data) {
            console.log('告警列表')
			let _this = this
			let params = {
				'enCode': "gaojingliebiao-TiDB",
				"@station_id": _this.stationId,
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return
                console.log(res, '最新告警列表')
                let newList = [];
                res.map(item => {
                    newList.push([
                        formatTime(item.timeOccurrence, 'yyyy-MM-dd'),
                        item.alarmEquipmentCode,
                        item.alarm_coent,
                        item.alarm_name
                    ])
                })
                this.config = {
                    headerBGC: "rgba(53, 149, 147, 0.2)",
                    headerHeight: 90,
                    carousel: "single",
                    hoverPause: true,
                    oddRowBGC: "rgba(53, 149, 147, 0)",
                    evenRowBGC: "rgba(53, 149, 147, 0)",
                    rowNum: 5, //表格行数
                    header: ["告警时间", "设备编码", "告警类别", "告警内容"],
                    data: newList,
                }
			})
			.catch((err) => {
				console.log(err, 'error');
			})
		},
        
        // 获取站点监控视频
        getDeviceList() {
            let params = {
                stationId: this.stationId
            }
            dataInterface.gclVideoLiveInfoExposition(params).then(res => {
                console.log('getDeviceList', res)
                if(!res) return
                this.videoList = (res.list || []).splice(0,4)
                this.$nextTick(() => {
                    this.videoList.forEach((v, i) => {
                    if (v.url) {
                        const playerDom = this.$refs[`my-player${i}`][0]
                        Object.assign(this.videoObj, {
                        [`video${i}`]: videojs(
                            playerDom,
                            {
                            autoplay: true, // 设置自动播放
                            controls: true, // 显示播放的控件
                            preload: 'metadata',
                            aspectRatio: '16:9',
                            fluid: true,
                            sources: [
                                // 注意，如果是以option方式设置的src,是不能实现 换台的 (即使监听了nowPlayVideoUrl也没实现)
                                {
                                    src: playerDom.attributes.playUrl.nodeValue,
                                    type: 'application/x-mpegURL', // 告诉videojs,这是一个hls流
                                },
                            ],
                            },
                            function () {
                            },
                        ),
                        })
                        
                    }
                    })
                })
            })
        }

    }
}
</script>

<style lang="scss" scoped>
@import '../scss/powerStationNew.scss';
.video-box-new {
    height: 610px;
    .video-item-new {
        width: 50%;
        height: 250px;
        padding: 10px;
		margin-bottom:100px;
        box-sizing: border-box;
        .video {
            width: 100%;
            height: 100%;
        }
    }
}

.newTable{
	line-height: 90px;
	font-size: 20px !important;
	  &.dv-scroll-board {
		 .header, .rows .row-item {
			 height: 90px !important;
		     // font-size: 20px !important;
		 }
	  }
}
</style>